(() => {
  const hubs = document.querySelectorAll('[data-one-learn-hub]');
  if (!hubs.length) return;

  const safeLessonDestination = value => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin) return null;
      if (!/^\/pages\/learn-to-skate-level-(?:10|[1-9])$/.test(url.pathname)) return null;
      if (!/^#lesson-lts-l(?:10|0[1-9])-[0-9]{2}$/.test(url.hash)) return null;
      return url.pathname + url.hash;
    } catch {
      return null;
    }
  };

  hubs.forEach(async hub => {
    if (hub.dataset.progressReady === 'true') return;
    hub.dataset.progressReady = 'true';
    const region = hub.querySelector('[data-one-hub-progress]');
    if (!region) return;
    try {
      const response = await fetch('/apps/one-academy/learn-progress', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const data = await response.json();
      if (!data?.signedIn || !data.progress || Number(data.progress.totalCompleted) < 1) return;

      const progress = data.progress;
      const level = region.querySelector('[data-one-hub-progress-level]');
      const lesson = region.querySelector('[data-one-hub-progress-lesson]');
      const link = region.querySelector('[data-one-hub-progress-link]');
      if (!level || !lesson || !link) return;

      if (progress.allLessonsCompleted) {
        level.textContent = 'Learn to Skate complete';
        lesson.textContent = `${progress.totalCompleted} of ${progress.totalLessons} lessons completed`;
        link.textContent = 'Review Learn to Skate';
        link.href = '/pages/learn-to-skate';
      } else {
        const destination = safeLessonDestination(progress.nextLesson?.url);
        if (!destination) return;
        level.textContent = `Level ${progress.nextLesson.level}`;
        lesson.textContent = `Next: ${progress.nextLesson.title}`;
        link.textContent = 'Continue';
        link.href = destination;
      }

      region.hidden = false;
    } catch {
      // Public Learn remains complete when authenticated enhancement is unavailable.
    }
  });
})();
